export default class rs {
  constructor(t) {
    (this.tf = t), (this.tf = t);
  }
  sf(t) {
    return null == this.tf || this.tf === t[0];
  }
  static fromJson(t) {
    return new rs(t ? t.event_name : null);
  }
  gt() {
    return this.tf;
  }
}
